
import { PromotionSchema } from '@weft/types';
import type { PromotionInput, Promotion, Currency } from '@weft/types';
import React from 'react';
import { PromotionChargeEdit } from './PromotionChargeEdit';
import { PromotionChargeView } from './PromotionChargeView';

export type PromotionCardProps = {
  editable: boolean;
  promotionIndex: number;
  promotion: Promotion | PromotionInput;
  currency: Currency
};

export const PromotionCharge: React.FC<PromotionCardProps> = ({
  editable,
  promotionIndex,
  promotion,
  currency,
}) => {
  const createPromotionCharge = usePromotionChargeFactory(currency);

  return createPromotionCharge(promotion, promotionIndex, editable);
};

function usePromotionChargeFactory(currency: Currency) {
  return (promotion: Promotion | PromotionInput, promotionIndex: number, editable: boolean) => {
    if (editable) {
      return <PromotionChargeEdit promotionIndex={promotionIndex} />;
    }

    const parsedPromotion = PromotionSchema.parse(promotion);

    return (
      <PromotionChargeView
        promotion={parsedPromotion}
        promotionIndex={promotionIndex}
        currency={currency}
      />
    );
  };
}